import React from 'react'
import * as Yup from "yup"
import {useHistory} from 'react-router-dom'
import {useTranslation} from "react-i18next"
import store from "@formApp/store"

export default ({form}) => {
  const {formValues, domainsList, transitions, formErrors} = React.useContext(store);
  let history = useHistory();
  const {t} = useTranslation();
  const selectedItem = domainsList.getSelected();
  if (!selectedItem) history.push('step-1');

  let authcodeValid = {success:false, value:''};
  Yup.addMethod(Yup.string, 'authcode', function (message) {
    return this
      .test({
        name: 'authcode',
        message: message,
        test: async function (value) {
          if (value && value.length > 0 && value != authcodeValid.value) {
            authcodeValid.value = value;
            const response = await fetch(`https://aa.altervista.org/ajax-domain.php?action=check_transfer&domain=${formValues.getValue('siteName')}&tld=${selectedItem.domain.replace('.','')}&authinfo=${value}`)
            const json = await response.json()
            if (authcodeValid.success != json.success) authcodeValid.success = json.success;
          }
          return authcodeValid.success;
        }
      })
  })

  let initialValues = {
    token: window.alterToken,
    TipoAccount: accountType,
    siteName: formValues.getValue('siteName'),
    domain: selectedItem.domain,
    entity: formValues.getValue('entity') || '1',
    taxid: formValues.getValue('taxid') || '',
    Nome: formValues.getValue('Nome') || '',
    Cognome: formValues.getValue('Cognome') || '',
    Birth: formValues.getValue('Birth') || '',
    nation: formValues.getValue('nation') || 'IT',
    address: formValues.getValue('address') || '',
    zip: formValues.getValue('zip') || '',
    city: formValues.getValue('city') || '',
    prov: formValues.getValue('prov') || '',
    dial_code: formValues.getValue('dial_code') || '39',
    phone: formValues.getValue('phone') || '',
    Email: formValues.getValue('Email') || '',
    mailConfirm: formValues.getValue('mailConfirm') || '',
    termsAcceptance: formValues.getValue('termsAcceptance') || false,
    fullDomainName: `www.${formValues.getValue('siteName')}${selectedItem.domain}`
  };
  
  let validationSchema = {
    siteName: Yup.string()
      .max(63, t('Il nome del sito web non è valido, deve essere massimo 63 caratteri'))// todo: controllare max num di caratteri
      .matches(/^[a-z]/i, t('Il nome del sito web non è valido, deve cominciare con una lettera'))
      .matches(/[a-zA-Z0-9-]+$/, t('Il nome del sito web non è valido, deve contenere solo numeri e lettere non accentate'))
      .required(t('Il nome del dominio è obbligatorio')),
    entity: Yup.string().required(t('Indicare il tipo di registrante')),
    Nome: Yup.string().required(t('no_Nome')),
    Cognome: Yup.string().required(t('no_Cognome')),
    Birth: Yup.string().required(t('no_Birth')),
    nation: Yup.string().required(t('no_nation')),
    address: Yup.string().required(t('no_address')),
    zip: Yup.string().when('nation', {
      is: 'IT',
      then: Yup.string().matches(/^\d{5}$/, t('err_zip')),
    }).required(t('no_zip')),
    city: Yup.string().required(t('no_city')),
    prov: Yup.string().when('nation', {
      is: 'IT',
      then: Yup.string().matches(/^[A-Z]{2}$/i, t('Indica la sigla della provincia'))
    }).required(t('no_prov')),
    dial_code: Yup.string().matches(/^\d{1,3}$/, t('err_dial_code')).required(t('no_dial_code')),
    phone: Yup.string().matches(/^[\d]+$/i, t('err_phone')).required(t('no_phone')),
    Email: Yup.string().email(t('err_Email')).required(t('no_Email')),
    mailConfirm: Yup.string().oneOf([Yup.ref('Email'), null], t('Le email non corrispondono')).required(t('Devi confermare la tua email')),
    termsAcceptance: Yup.boolean().oneOf([true], t('err_confirm'))
  };

  if (selectedItem.transfer) {
    initialValues = {
      ...initialValues,
      authCode: formValues.getValue('authCode') || '',
      transfer: 1,
    }
    validationSchema = {
      ...validationSchema,
      authCode: Yup.string().required(t('Inserisci un authcode valido')).authcode(t('Authcode non valido'))
    }
  }

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      formErrors.clear();
      formValues.set(values);

      const formEncoded = new URLSearchParams();
      for (let field in values) {
        formEncoded.append(field, values[field]);
      }
      const res = await fetch('https://aa.altervista.org/cgi-bin/joinus-domain.pl', {
        method: 'POST',
        body: formEncoded
      });
      if (!res.ok) throw new Error(res.statusText);
      const data = await res.json();
      if (data.status === 'ok') {
        transitions.setCurrent('domainSelected');
        formValues.setValue('dataId', data.id);
        formValues.setValue('paypalParams', data.paypal_params);
        history.push('step-3');
      } else {
        if (data.status === 'error' && data.error_code === 'validation') {
          data.error_details.forEach(error => {
            formErrors.addToHead(t(error));// i18next-extract-disable-line
          });
          // i campi errati si ricavano dall'array data.error_details, che contiene n elementi quanti sono gli errori rilevati
          // gli errori possibili sono:
          // -> 'no_[nome campo]' per i campi mancanti (non dovrebbe succedere con la validazione del form)
          // -> 'err_[nome campo]' per i campi errati (raro, ma possibile, alcune regole non sono mappate nella validazione lato client)

        } else {
          formErrors.addToHead(data.error_message);
          // data.error_code è numerico, indica un messaggio di errore tipo https://aa.altervista.org/message.php?error=$err_code
          // in questi casi la registrazione può essere interrotta, il testo del messaggio già tradotto è in data.error_message, può contenere html
        }
      }
    } catch (err) {
      formErrors.addToHead(err);
    }
    setSubmitting(false);
  };

  return (
    form(initialValues, validationSchema, onSubmit)
  )
}